<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/stock/bills/index' }">出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>跨公司调拨</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="发起跨公司调拨" name="save" :disabled="isReceiveMode">
        <template v-if="!isReceiveMode">
          <el-alert v-if="lastSavedBillCode" type="success" :closable="false" show-icon>
            <template #title>
              申请成功，来源出库单号：
              <el-link type="success" :underline="false" @click="openReceiveBySource(lastSavedBillCode)">{{
                lastSavedBillCode }}</el-link>
            </template>
          </el-alert>

          <el-form :model="saveForm" label-width="130px" class="search-form" style="margin-top: 10px;">
            <el-row>
              <el-form-item label="来源公司" required>
                <el-tree-select v-model="saveForm.companyID" :data="sourceCompanys" check-strictly
                  :render-after-expand="false" :disabled="saveBounds.length > 0" style="width: 220px" />
              </el-form-item>
              <el-form-item label="接收方公司" required>
                <el-tree-select v-model="saveForm.targetCompanyID" :data="targetCompanys" check-strictly
                  :render-after-expand="false" style="width: 220px" />
              </el-form-item>

              <el-form-item label="出库单号" required>
                <el-input v-model="saveForm.billCode" disabled style="width: 220px" />
              </el-form-item>
              <el-form-item label="单据类型">
                <el-input :model-value="saveForm.billType" disabled style="width: 220px" />
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :xs="18" :sm="20" :md="22">
                <el-form-item label="备注">
                  <el-input v-model="saveForm.remark" type="textarea" :rows="2" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div class="toolbar">
            <el-button type="primary" plain icon="Plus" @click="openAddSaveDialog">添加出库货品</el-button>
            <el-button plain icon="Refresh" @click="refreshBillCode">重置单号</el-button>
            <el-button type="danger" plain icon="Delete" @click="saveBounds = []"
              :disabled="saveBounds.length === 0">清空明细</el-button>
          </div>

          <el-table :data="saveBounds" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" width="55" align="center" />
            <el-table-column prop="detailCode" label="系统款号" width="130" />
            <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
            <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center" />
            <el-table-column prop="unitName" label="规格" width="100" align="center" />
            <el-table-column prop="serialCode" label="批次号" width="130" />
            <el-table-column prop="storeCode" label="库房" width="90" />
            <el-table-column prop="channel" label="渠道" width="100" />
            <el-table-column label="转移数量" width="110" align="center">
              <template #default="scope">
                <el-input v-model.number="scope.row.stockNumber" type="number" min="1" size="small" />
              </template>
            </el-table-column>
            <el-table-column prop="stockRemain" label="可用库存" width="90" align="center" />
            <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
            <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right" /> -->
            <el-table-column label="操作" width="80" align="center">
              <template #default="scope">
                <el-button type="primary" link size="small" @click="removeSaveBound(scope.row)">[删除]</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="summary-row">来源库存合计金重：{{ saveGoldWeightTotal.toFixed(2) }} g</div>

          <div class="submit-row">
            <el-button type="primary" icon="Check" :loading="saveLoading" @click="submitSave">提交出库</el-button>
          </div>

          <el-dialog title="新增出库货品" v-model="showAddDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
            <el-form :model="searchForm" label-width="110px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="货品批次号">
                    <el-input v-model="searchForm.serialCode" placeholder="请输入批次号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="系统款号">
                    <el-input v-model="searchForm.detailCode" placeholder="请输入系统款号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="品牌款号">
                    <el-input v-model="searchForm.brandModelCode" placeholder="请输入品牌款号" clearable
                      @keyup.enter="searchSaveStock"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="出库公司">
                    <el-tree-select v-model="saveForm.companyID" :data="sourceCompanys" clearable check-strictly
                      :render-after-expand="false" style="width: 100%" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来源库房">
                    <el-select v-model="searchForm.storeCode" placeholder="请选择库房" clearable style="width: 100%">
                      <el-option v-for="item in dict.stores" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来源渠道">
                    <el-select v-model="searchForm.channel" placeholder="请选择渠道" clearable style="width: 100%">
                      <el-option v-for="item in dict.channels" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

                <el-row>
                  <el-col :span="24" style="text-align: center;">
                    <el-button type="primary" icon="Search" @click="searchSaveStock"
                      :loading="searchLoading">查询货品</el-button>
                    <el-button @click="resetSaveSearchForm">重置</el-button>
                    <el-button type="success" icon="Plus" @click="batchAddSaveBounds"
                      :disabled="searchSelectedItems.length === 0">批量添加 ({{ searchSelectedItems.length }})</el-button>
                  </el-col>
                </el-row>
              </el-form>

            <el-divider></el-divider>

            <el-table :data="searchResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
              v-loading="searchLoading" @selection-change="handleSaveSearchSelectionChange">
              <el-table-column type="selection" width="50" align="center"></el-table-column>
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column prop="serialCode" label="批次号" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="detailCode" label="系统款号" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                show-overflow-tooltip></el-table-column>
              <el-table-column prop="detailName" label="货品名称" min-width="140" show-overflow-tooltip></el-table-column>
              <el-table-column prop="storeCode" label="库房" width="90" align="center"></el-table-column>
              <el-table-column prop="channel" label="渠道" width="90" align="center"></el-table-column>
              <el-table-column prop="stockRemain" label="可用库存" width="90" align="right"></el-table-column>
              <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
              <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right"></el-table-column>
              <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right"></el-table-column> -->
            </el-table>

            <template #footer>
              <span class="dialog-footer">
                <el-button @click="showAddDialog = false">取消</el-button>
              </span>
            </template>
          </el-dialog>
        </template>

      </el-tab-pane>

      <el-tab-pane label="跨公司调拨详情" name="receive" :disabled="!isReceiveMode">
        <template v-if="isReceiveMode">
          <el-form :inline="true" class="search-form">
            <el-form-item label="来源出库单号">
              <el-input v-model="sourceBillCode" placeholder="请输入来源出库单号" style="width: 260px"
                @keyup.enter="loadBySourceBillCode" />
            </el-form-item>
            <el-form-item>
              <el-button type="info" icon="Search" @click="loadBySourceBillCode">查询</el-button>
            </el-form-item>
          </el-form>

          <el-tabs v-model="receiveSubTab" class="receive-sub-tabs">
            <el-tab-pane label="来源出库信息" name="source">
              <el-descriptions border :column="4" size="small" v-if="sourceBill">
                <el-descriptions-item label="来源出库单号">{{ sourceBill.billCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源公司">{{ companyName(sourceBill.companyID) }}</el-descriptions-item>
                <el-descriptions-item label="接收公司">{{ companyName(sourceBill.targetCompanyID || (receiveBill && receiveBill.companyID))
                }}</el-descriptions-item>
                <el-descriptions-item label="来源库房">{{ sourceBill.storeCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源渠道">{{ sourceBill.channelCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="单据类型">{{ sourceBill.billType || '-' }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                  <el-tag :type="statusTagType(sourceBill.status)" effect="dark">{{ statusText(sourceBill.status) }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="接收单状态">
                  <el-tag :type="statusTagType(receiveBill && receiveBill.status)" effect="dark">{{ statusText(receiveBill && receiveBill.status) }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="备注">{{ sourceBill.remark || '-' }}</el-descriptions-item>
              </el-descriptions>

              <el-divider>预调拨明细</el-divider>
              <el-table :data="sourceBounds" stripe border size="small" style="width: 100%; margin-top: 12px;">
                <el-table-column type="index" label="序号" width="55" align="center" />
                <el-table-column prop="detailCode" label="系统款号" width="130" />
                <el-table-column prop="brandModelCode" label="公司款号" width="120" />
                <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column prop="unitName" label="规格" width="100" align="center" />
                <el-table-column prop="serialCode" label="批次号" width="130" />
                <el-table-column prop="storeCode" label="来源库房" width="100" />
                <el-table-column prop="channel" label="来源渠道" width="100" />
                <el-table-column prop="stockNumber" label="来源出库数量" width="120" align="center" />
                <el-table-column label="接收状态" width="110" align="center">
                  <template #default="scope">
                    <el-tag
                      :type="sourceReceiveStatusTagType(scope.row.status)"
                      effect="plain"
                    >
                      {{ sourceReceiveStatusText(scope.row.status) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right" /> -->
              </el-table>

              <div class="summary-row">明细合计金重：{{ sourceGoldWeightTotal.toFixed(2) }} g</div>

              <el-divider>对方实际接收明细</el-divider>
              <el-table :data="receiveResultBounds" stripe border size="small" style="width: 100%; margin-top: 12px;">
                <el-table-column type="index" label="序号" width="55" align="center" />
                <el-table-column prop="detailCode" label="系统款号" width="130" />
                <el-table-column prop="brandModelCode" label="公司款号" width="120" />
                <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column prop="unitName" label="规格" width="100" align="center" />
                <el-table-column prop="serialCode" label="批次号" width="130" />
                <el-table-column prop="storeCode" label="接收库房" width="100" />
                <el-table-column prop="channel" label="接收渠道" width="100" />
                <el-table-column prop="stockNumber" label="接收入库数量" width="120" align="center" />
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right" /> -->
              </el-table>

              <div class="summary-row">对方实际接收合计金重：{{ receiveGoldWeightTotal.toFixed(2) }} g</div>
            </el-tab-pane>

            <el-tab-pane label="接收公司入库" name="receive">

              <div class="submit-row">
                <el-button type="primary" icon="Check" v-if="!hasReceived && canOperateReceive" :loading="receiveLoading"
                  @click="submitReceiveResult" style="margin-bottom: 10px;">保存提交</el-button>
                <el-button type="info" plain icon="Printer" @click="printReceivePreview" style="margin-bottom: 10px;"
                  :disabled="!sourceBillCode">打印预览</el-button>
              </div>
              <div class="submit-row" v-if="!hasReceived && canOperateReceive">
                <el-button type="success" plain size="small" @click="batchSetReceiveAction('Receive')"
                  :disabled="receiveSelectedRows.length === 0" style="margin-bottom: 10px;">
                  批量设为接收 ({{ receiveSelectedRows.length }})
                </el-button>
                <el-button type="danger" plain size="small" @click="batchSetReceiveAction('Reject')"
                  :disabled="receiveSelectedRows.length === 0" style="margin-bottom: 10px;">
                  批量设为拒绝 ({{ receiveSelectedRows.length }})
                </el-button>
              </div>

              <el-form v-if="!hasReceived && canOperateReceive" label-width="140px" style="margin-bottom: 10px;">
                <el-form-item label="批次号批量接收">
                  <el-input
                    v-model="receiveSerialInput"
                    placeholder="支持多个批次号；可用逗号、中文逗号、空格、换行、分号分隔"
                    @keydown.enter.prevent="markReceiveBySerialInput"
                  />
                  <div style="margin-top: 8px;">
                    <el-button type="success" plain size="small" @click="markReceiveBySerialInput">标记为接收</el-button>
                    <el-button size="small" @click="receiveSerialInput = ''">清空输入</el-button>
                  </div>
                  <el-alert
                    v-if="receiveUnmatchedSerials.length > 0"
                    type="warning"
                    :closable="false"
                    show-icon
                    style="margin-top: 8px;"
                    :title="`以下批次号未命中明细：${receiveUnmatchedSerials.join('，')}`"
                  />
                </el-form-item>
              </el-form>

              <el-descriptions border :column="4" size="small" style="margin-bottom: 10px;">
                <el-descriptions-item label="来源出库单号">{{ (sourceBill && sourceBill.billCode) || sourceBillCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="接收单号">{{ expectedReceiveBillCode || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源公司">{{ companyName(sourceBill && sourceBill.companyID) }}</el-descriptions-item>
                <el-descriptions-item label="接收公司">{{ companyName((sourceBill && sourceBill.targetCompanyID) || (receiveBill && receiveBill.companyID)) }}</el-descriptions-item>
                <el-descriptions-item label="来源库房">{{ (sourceBill && sourceBill.storeCode) || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源渠道">{{ (sourceBill && sourceBill.channelCode) || '-' }}</el-descriptions-item>
                <el-descriptions-item label="来源单状态">
                  <el-tag :type="statusTagType(sourceBill && sourceBill.status)" effect="dark">{{ statusText(sourceBill && sourceBill.status) }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="接收单状态">
                  <el-tag :type="statusTagType(receiveBill && receiveBill.status)" effect="dark">{{ statusText(receiveBill && receiveBill.status) }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="处理统计">接收 {{ receiveActionCount }} 条，拒绝 {{ rejectActionCount }} 条，待处理 {{ pendingReceiveCount }} 条</el-descriptions-item>
              </el-descriptions>

              <el-table :data="receiveBounds" stripe border size="small" style="width: 100%"
                @selection-change="handleReceiveSelectionChange">
                <el-table-column v-if="!hasReceived && canOperateReceive" type="selection" width="50" align="center" />
                <el-table-column type="index" label="序号" width="55" align="center" />
                <el-table-column prop="detailCode" label="系统款号" width="130" />
                <el-table-column prop="brandModelCode" label="公司款号" width="120" />
                <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                <el-table-column prop="unitName" label="规格" width="100" align="center" />
                <el-table-column prop="serialCode" label="批次号" width="130" />
                <el-table-column prop="stockNumber" label="接收入库数量" width="120" align="center" />
                <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right" /> -->
                <el-table-column prop="sourceStockNumber" label="来源出库数量" width="120" align="center" />
                <el-table-column label="处理动作" width="220" align="center">
                  <template #default="scope">
                    <el-radio-group v-model="scope.row.action" :disabled="hasReceived || !canOperateReceive">
                      <el-radio-button label="Receive">接收</el-radio-button>
                      <el-radio-button label="Reject">拒绝</el-radio-button>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column label="拒绝备注" min-width="160">
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.rejectRemark"
                      size="small"
                      placeholder="可选，拒绝时填写"
                      :disabled="hasReceived || !canOperateReceive || scope.row.action !== 'Reject'"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <div class="summary-row">明细合计金重：{{ sourceGoldWeightTotal.toFixed(2) }} g</div>

              <el-divider v-if="!hasReceived"></el-divider>

              <template v-if="hasReceived">
                <el-divider>接收结果</el-divider>
                <el-descriptions border :column="4" size="small" v-if="receiveBill">
                  <el-descriptions-item label="接收入库单号">{{ receiveBill.billCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="接收公司">{{ companyName(receiveBill.companyID) }}</el-descriptions-item>
                  <el-descriptions-item label="关联来源单">{{ receiveBill.sourceBillCode || receiveBill.netCode || '-'
                  }}</el-descriptions-item>
                  <el-descriptions-item label="状态">{{ statusText(receiveBill.status) }}</el-descriptions-item>
                  <el-descriptions-item label="接收库房">{{ receiveBill.storeCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="接收渠道">{{ receiveBill.channelCode || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="单据类型">{{ receiveBill.billType || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="备注">{{ receiveBill.remark || '-' }}</el-descriptions-item>
                </el-descriptions>

                <el-table :data="receiveResultBounds" stripe border size="small" style="width: 100%; margin-top: 12px;">
                  <el-table-column type="index" label="序号" width="55" align="center" />
                  <el-table-column prop="detailCode" label="系统款号" width="130" />
                  <el-table-column prop="brandModelCode" label="公司款号" width="120" />
                  <el-table-column prop="detailName" label="名称" min-width="140" show-overflow-tooltip />
                  <el-table-column prop="unitName" label="规格" width="100" align="center" />
                  <el-table-column prop="serialCode" label="批次号" width="130" />
                  <el-table-column prop="storeCode" label="接收库房" width="100" />
                  <el-table-column prop="channel" label="接收渠道" width="100" />
                  <el-table-column prop="stockNumber" label="接收入库数量" width="120" align="center" />
                  <el-table-column prop="weight" label="货重(g)" width="90" align="right" />
                  <el-table-column prop="goldWeight" label="金重(g)" width="90" align="right" />
                  <!-- <el-table-column prop="productPrice" label="入库价" width="90" align="right" /> -->
                </el-table>

                <div class="summary-row">接收公司入库合计金重：{{ receiveGoldWeightTotal.toFixed(2) }} g</div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import {
  fetchBillCode,
  fetchBillByCode,
  fetchGroupBySerialCode,
  submitCrossTransferSubmit,
  submitCrossTransferSave,
} from "@/api/stock";
import { getCompanyTreeAll } from "@/api/basic";

export default {
  name: "CrossTransfer",
  data() {
    return {
      activeTab: "save",
      receiveSubTab: "receive",
      saveLoading: false,
      receiveLoading: false,
      sourceCompanys: [],
      targetCompanys: [],
      companyMap: {},
      dict: { stores: [], channels: [] },
      showAddDialog: false,
      searchLoading: false,
      searchResults: [],
      searchSelectedItems: [],
      searchForm: {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: "",
      },
      saveBounds: [],
      lastSavedBillCode: "",
      sourceBillCode: "",
      sourceBill: null,
      sourceBounds: [],
      receiveBill: null,
      receiveResultBounds: [],
      receiveBounds: [],
      receiveSelectedRows: [],
      receiveSerialInput: "",
      receiveUnmatchedSerials: [],
      saveForm: {
        companyID: "",
        billCode: "",
        billType: "跨公司调拨出库",
        targetCompanyID: "",
        remark: "",
      },
    };
  },
  computed: {
    isReceiveMode() {
      const query = this.$route.query || {};
      return !!(query.billCode || "").trim();
    },
    saveGoldWeightTotal() {
      return this.saveBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    sourceGoldWeightTotal() {
      return this.sourceBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    receiveGoldWeightTotal() {
      return this.receiveResultBounds.reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
    },
    hasReceived() {
      return this.receiveResultBounds.length > 0;
    },
    canOperateReceive() {
      const sourceStatus = Number((this.sourceBill && this.sourceBill.status) ?? NaN);
      const receiveStatus = Number((this.receiveBill && this.receiveBill.status) ?? NaN);
      return sourceStatus === 0 && receiveStatus === 0;
    },
    pendingReceiveCount() {
      return this.receiveBounds.filter((item) => !item.action).length;
    },
    receiveActionCount() {
      return this.receiveBounds.filter((item) => item.action === "Receive").length;
    },
    rejectActionCount() {
      return this.receiveBounds.filter((item) => item.action === "Reject").length;
    },
    expectedReceiveBillCode() {
      const sourceCode = (this.sourceBill && this.sourceBill.billCode) || this.sourceBillCode;
      return sourceCode ? `${sourceCode}-R` : "";
    },
  },
  methods: {
    statusText(status) {
      if (status === -1) return "已取消";
      if (status === 0) return "待审核";
      if (status === 1) return "已审核";
      if (status === 2) return "已完成";
      return status == null ? "-" : String(status);
    },
    statusTagType(status) {
      const s = Number(status);
      if (s === -1) return "danger";
      if (s === 0) return "warning";
      if (s === 1) return "success";
      if (s === 2) return "primary";
      return "info";
    },
    isReceiveBillProcessed() {
      const receiveStatus = Number((this.receiveBill && this.receiveBill.status) ?? NaN);
      return !Number.isNaN(receiveStatus) && receiveStatus !== 0;
    },
    sourceReceiveStatusText(status) {
      const s = String(status ?? "");
      if (s === "-1") return "已退回";
      if (s === "0") return this.isReceiveBillProcessed() ? "已接收" : "待处理";
      return "待处理";
    },
    sourceReceiveStatusTagType(status) {
      const s = String(status ?? "");
      if (s === "-1") return "danger";
      if (s === "0") return this.isReceiveBillProcessed() ? "success" : "info";
      return "info";
    },
    printReceiveStatusText(row) {
      const s = String((row && row.status) ?? "");
      if (s === "-1" || (row && row.action) === "Reject") return "退回";
      if (s === "0" && this.isReceiveBillProcessed()) return "接收";
      if ((row && row.action) === "Receive") return "接收";
      return "待办";
    },
    truncatePrintName(name) {
      const text = String(name || "");
      return text.length > 12 ? `${text.slice(0, 12)}...` : text;
    },
    companyName(companyID) {
      return this.companyMap[companyID] || companyID || "-";
    },
    getRouteBillCode() {
      const query = this.$route.query || {};
      return (query.billCode || "").trim().replace(/-R$/i, "");
    },
    openReceiveBySource(sourceBillCode) {
      const billCode = (sourceBillCode || "").trim();
      if (!billCode) return;
      this.$router.push({ path: "/stock/bills/crossTransfer", query: { billCode } });
    },
    syncFromRoute() {
      const query = this.$route.query || {};
      const billCode = (query.billCode || "").trim();

      if (billCode) {
        this.activeTab = "receive";
        this.receiveSubTab = "receive";
        this.sourceBillCode = billCode.replace(/-R$/i, "") || billCode;
        if (this.sourceBillCode) this.loadBySourceBillCode();
      } else {
        this.activeTab = "save";
        this.receiveSubTab = "receive";
        this.sourceBillCode = "";
        this.sourceBill = null;
        this.sourceBounds = [];
        this.receiveBill = null;
        this.receiveResultBounds = [];
        this.receiveBounds = [];
        this.receiveSerialInput = "";
        this.receiveUnmatchedSerials = [];
        this.refreshBillCode();
      }
    },
    refreshBillCode(force = false) {
      const routeBillCode = this.getRouteBillCode();
      if (!force && routeBillCode) {
        this.saveForm.billCode = routeBillCode;
        return Promise.resolve(routeBillCode);
      }

      return fetchBillCode({ billType: "跨公司调拨出库", prev: "CKDB" }).then((res) => {
        this.saveForm.billCode = res.data || "";
      });
    },
    openAddSaveDialog() {
      if (!this.saveForm.companyID) {
        this.$message({ type: "warning", message: "请选择来源公司" });
        return;
      }

      this.showAddDialog = true;
      this.searchResults = [];
      this.searchSelectedItems = [];
      this.resetSaveSearchForm();
    },
    resetSaveSearchForm() {
      this.searchForm = {
        serialCode: "",
        detailCode: "",
        brandModelCode: "",
        storeCode: "",
        channel: "",
      };
      this.searchResults = [];
      this.searchSelectedItems = [];
    },
    searchSaveStock() {
      if (!this.saveForm.companyID) {
        this.$message({ type: "warning", message: "请先选择来源公司" });
        return;
      }
      if (!this.searchForm.serialCode && !this.searchForm.detailCode && !this.searchForm.brandModelCode
        && !this.searchForm.storeCode && !this.searchForm.channel) {
        this.$message({ type: "warning", message: "请至少填写一个查询条件" });
        return;
      }

      this.searchLoading = true;
      this.searchResults = [];
      this.searchSelectedItems = [];

      const serialCodes = [];
      if (this.searchForm.serialCode) {
        const codes = this.searchForm.serialCode.split(',').map((code) => code.trim()).filter((code) => code);
        serialCodes.push(...codes);
      }

      fetchGroupBySerialCode(
        serialCodes,
        this.saveForm.companyID || "",
        this.searchForm.detailCode || "",
        this.searchForm.storeCode || "",
        this.searchForm.channel || "",
        this.searchForm.brandModelCode || ""
      ).then((res) => {
        this.searchLoading = false;
        if (res.code === 200) {
          const rows = (res.data || []).filter((item) => Number(item.stockRemain || 0) > 0);
          this.searchResults = rows;
          if (rows.length === 0) {
            this.$message({ type: "info", message: "未找到符合条件的来源库存" });
          }
        } else {
          this.$message({ type: "error", message: res.content || res.message || "查询失败" });
        }
      }).catch(() => {
        this.searchLoading = false;
        this.$message({ type: "error", message: "查询失败，请稍后重试" });
      });
    },
    handleSaveSearchSelectionChange(selection) {
      this.searchSelectedItems = selection;
    },
    batchAddSaveBounds() {
      if (this.searchSelectedItems.length === 0) {
        this.$message({ type: "warning", message: "请先勾选需要添加的货品" });
        return;
      }

      let addedCount = 0;
      let duplicateCount = 0;
      let invalidCount = 0;

      this.searchSelectedItems.forEach((item) => {
        const id = item.id || item.ID || "";
        const serialCode = item.serialCode || item.SerialCode || "";
        const uniqueKey = id || serialCode;
        if (!uniqueKey) {
          invalidCount += 1;
          return;
        }
        if (this.saveBounds.some((row) => (row.id || row.serialCode) === uniqueKey)) {
          duplicateCount += 1;
          return;
        }

        this.saveBounds.push({
          id,
          companyID: item.companyID || item.companyId || this.saveForm.companyID,
          storeCode: item.storeCode || "",
          channel: item.channel || item.channelCode || "",
          detailID: item.detailID || item.detailId || "",
          detailCode: item.detailCode || "",
          detailName: item.detailName || "",
          unitName: item.unitName || "",
          serialCode,
          brandSerialCode: item.brandSerialCode || "",
          brandCode: item.brandCode || "",
          brandModelCode: item.brandModelCode || "",
          stockNumber: 1,
          stockRemain: Number(item.stockRemain || item.stockNumber || 0),
          weight: Number(item.weight || 0),
          goldWeight: Number(item.goldWeight || 0),
          //productPrice: Number(item.productPrice || 0),
        });
        addedCount += 1;
      });

      const selectedKeySet = new Set(
        this.searchSelectedItems.map((item) => (item.id || item.ID || item.serialCode || item.SerialCode || ""))
          .filter((key) => !!key)
      );
      this.searchResults = this.searchResults.filter(
        (row) => !selectedKeySet.has(row.id || row.ID || row.serialCode || row.SerialCode || "")
      );
      this.searchSelectedItems = [];

      if (addedCount > 0) {
        let message = `成功添加 ${addedCount} 条货品`;
        if (duplicateCount > 0) message += `，${duplicateCount} 条重复已忽略`;
        if (invalidCount > 0) message += `，${invalidCount} 条数据不完整已忽略`;
        this.$message({ type: "success", message });
      } else if (duplicateCount > 0 || invalidCount > 0) {
        let message = "未添加任何货品";
        if (duplicateCount > 0) message += `，${duplicateCount} 条重复`;
        if (invalidCount > 0) message += `，${invalidCount} 条数据不完整`;
        this.$message({ type: "warning", message });
      }
    },
    removeSaveBound(row) {
      this.saveBounds = this.saveBounds.filter((item) => (item.id || item.serialCode) !== (row.id || row.serialCode));
    },
    validateSave() {
      if (!this.saveForm.companyID || !this.saveForm.targetCompanyID || !this.saveForm.billCode) {
        return "请完整填写原公司出库单必填字段";
      }
      if (this.saveForm.companyID === this.saveForm.targetCompanyID) {
        return "跨公司调拨时来源公司与接收公司不能相同";
      }
      if (this.saveBounds.length === 0) {
        return "请至少添加一条来源库存明细";
      }
      for (let i = 0; i < this.saveBounds.length; i++) {
        const row = this.saveBounds[i];
        if (!row.id) return `${i + 1}行 来源库存ID缺失`;
        if (!row.stockNumber || Number(row.stockNumber) <= 0) return `${i + 1}行 转移数量必须大于0`;
        if (Number(row.stockRemain) > 0 && Number(row.stockNumber) > Number(row.stockRemain)) {
          return `${i + 1}行 转移数量超过可用库存`;
        }
      }
      return "";
    },
    submitSave() {
      const msg = this.validateSave();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }

      const payload = {
        bill: {
          companyID: this.saveForm.companyID,
          billCode: this.saveForm.billCode,
          billType: this.saveForm.billType,
          storeCode: "",
          channelCode: "",
          remark: this.saveForm.remark,
        },
        bounds: this.saveBounds.map((item) => ({
          id: item.id,
          companyID: item.companyID || this.saveForm.companyID,
          storeCode: item.storeCode,
          channel: item.channel,
          detailID: item.detailID,
          detailCode: item.detailCode,
          detailName: item.detailName,
          unitName: item.unitName,
          serialCode: item.serialCode,
          brandSerialCode: item.brandSerialCode,
          brandCode: item.brandCode,
          brandModelCode: item.brandModelCode,
          stockNumber: Number(item.stockNumber || 0),
          goldWeight: Number(item.goldWeight || 0),
          //productPrice: Number(item.productPrice || 0),
        })),
      };

      const firstBound = this.saveBounds[0] || {};
      payload.bill.storeCode = firstBound.storeCode || "";
      payload.bill.channelCode = firstBound.channel || firstBound.channelCode || "";

      this.$confirm(
        "提交出库后，需要由接收公司账号执行“确认接收”操作；接收后来源公司库存才会实际出库，接收公司才会正式入库。是否继续提交？",
        "提交确认",
        {
          confirmButtonText: "继续提交",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.saveLoading = true;
        submitCrossTransferSave(payload, this.saveForm.targetCompanyID)
          .then((res) => {
            this.$message({ type: res.type || "success", message: res.content || "出库提交成功" });
            if (res.code === 200) {
              this.lastSavedBillCode = (res.data && (res.data.sourceBillCode || res.data.billCode)) || this.saveForm.billCode;
              const billCode = this.lastSavedBillCode;
              this.saveBounds = [];
              this.saveForm.remark = "";
              this.refreshBillCode(true);
              if (billCode) {
                this.$router.push({ path: "/stock/bills/crossTransfer", query: { billCode } });
              }
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }).catch(() => {
        // 用户取消提交
      });
    },
    async printReceivePreview() {
      if (!this.sourceBillCode) {
        this.$message({ type: "warning", message: "请先选择来源出库单号" });
        return;
      }

      const rows = this.receiveBounds;
      if (!rows || rows.length === 0) {
        this.$message({ type: "warning", message: "暂无可打印明细" });
        return;
      }

      const printData = rows.map((item, index) => ({
        序号: index + 1,
        系统款号: item.detailCode || "",
        名称: this.truncatePrintName(item.detailName),
        规格: item.unitName || "",
        批次号: item.serialCode || "",
        库房: item.storeCode || "",
        渠道: item.channel || "",
        数量: Number(item.stockNumber || 0),
        金重: Number(item.goldWeight || 0),
        //入库价: Number(item.productPrice || 0),
        状态: this.printReceiveStatusText(item),
      }));
      const actionRows = this.receiveBounds || [];
      const receiveTotalGoldWeight = actionRows
        .filter((item) => item.action === "Receive")
        .reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
      const rejectTotalGoldWeight = actionRows
        .filter((item) => item.action === "Reject")
        .reduce((sum, item) => sum + Number(item.stockNumber || 0) * Number(item.goldWeight || 0), 0);
      printData.push({
        序号: "",
        系统款号: "",
        名称: "接收合计金重",
        规格: "",
        批次号: "",
        库房: "",
        渠道: "",
        数量: "",
        金重: Number(receiveTotalGoldWeight || 0).toFixed(2),
        //入库价: "",
        状态: "",
      });
      printData.push({
        序号: "",
        系统款号: "",
        名称: "退回合计金重",
        规格: "",
        批次号: "",
        库房: "",
        渠道: "",
        数量: "",
        金重: Number(rejectTotalGoldWeight || 0).toFixed(2),
        //入库价: "",
        状态: "",
      });
      const sourceCompany = this.companyName(
        (this.sourceBill && this.sourceBill.companyID) || (this.saveForm && this.saveForm.companyID) || ""
      );
      const targetCompany = this.companyName(
        (this.receiveBill && this.receiveBill.companyID)
        || (this.sourceBill && this.sourceBill.targetCompanyID)
        || (this.saveForm && this.saveForm.targetCompanyID)
        || ""
      );
      const signBill = this.receiveBill || this.sourceBill || {};
      const signValue = (val) => (val && String(val).trim() ? String(val).trim() : "________");
      const printHeader = `
        <div style="text-align:center;">
          <h3 style="margin:0 0 8px 0;">跨公司调拨接收预览</h3>
          <div style="font-size:12px;margin-bottom:4px;">
            来源单号：${this.sourceBillCode || "-"}　
            接收单号：${this.expectedReceiveBillCode || "-"}
          </div>
          <div style="font-size:12px;margin-bottom:4px;">
            调出公司：${sourceCompany || "-"}　
            接收公司：${targetCompany || "-"}
          </div>
          <div style="font-size:12px;display:flex;justify-content:space-between;gap:12px;margin-bottom:8px;">
            <span>操作：${signValue(signBill.operatorName)}</span>
            <span>交接/审核：${signValue(signBill.handoverName)}</span>
            <span>复核/出库：${signValue(signBill.reviewerName)}</span>
            <span>财务：${signValue(signBill.financerName)}</span>
          </div>
        </div>
      `;

      const printJSModule = await import("print-js");
      const printJS = printJSModule.default || printJSModule;
      printJS({
        header: printHeader,
        printable: printData,
        properties: ["序号", "系统款号", "名称", "规格", "批次号", "库房", "渠道", "数量", "金重", /* "入库价", */ "状态"],
        type: "json",
        gridHeaderStyle: "font-size:0.8em;border: 1px solid #ccc;white-space:nowrap",
        gridStyle: "font-size:0.8em;border: 1px solid #ccc;text-align:center;white-space:nowrap",
      });
    },
    async loadBySourceBillCode() {
      this.sourceBillCode = (this.sourceBillCode || "").trim().replace(/-R$/i, "");
      if (!this.sourceBillCode) {
        this.$message({ type: "warning", message: "请输入来源出库单号" });
        return;
      }

      this.sourceBill = null;
      this.sourceBounds = [];
      this.receiveBill = null;
      this.receiveResultBounds = [];
      this.receiveBounds = [];
      this.receiveSelectedRows = [];
      this.receiveSerialInput = "";
      this.receiveUnmatchedSerials = [];

      const sourceRes = await fetchBillByCode(this.sourceBillCode);
      if (sourceRes.code !== 200 || !sourceRes.data || !sourceRes.data.bill) {
        this.$message({ type: "warning", message: sourceRes.content || "未查询到数据" });
        return;
      }

      this.sourceBill = sourceRes.data.bill;
      const sourceRows = (sourceRes.data.prebounds && sourceRes.data.prebounds.length > 0)
        ? sourceRes.data.prebounds
        : (sourceRes.data.bounds || []);

      this.sourceBounds = sourceRows.map((item) => ({
        id: item.id || item.ID,
        detailID: item.detailID,
        detailCode: item.detailCode,
        detailName: item.detailName,
        unitName: item.unitName,
        serialCode: item.serialCode,
        storeCode: item.storeCode,
        channel: item.channel || item.channelCode,
        brandSerialCode: item.brandSerialCode,
        brandCode: item.brandCode,
        brandModelCode: item.brandModelCode,
        stockNumber: Number(item.stockNumber || 0),
        goldWeight: Number(item.goldWeight || 0),
        //productPrice: Number(item.productPrice || 0),
        status: item.status,
      }));

      const sourceStockMap = {};
      this.sourceBounds.forEach((item) => {
        const key = `${item.id || ""}_${item.serialCode || ""}`;
        sourceStockMap[key] = Number(item.stockNumber || 0);
      });

      this.receiveBounds = this.sourceBounds.map((item) => ({
        ...item,
        sourceStockNumber: Number(item.stockNumber || 0),
        action: "",
        rejectRemark: "",
      }));

      const receiveCandidates = Array.from(new Set([
        this.expectedReceiveBillCode,
        (this.sourceBill && this.sourceBill.netCode) || "",
      ].filter((code) => !!code)));

      let receiveRes = null;
      for (let i = 0; i < receiveCandidates.length; i++) {
        const candidateRes = await fetchBillByCode(receiveCandidates[i]);
        if (candidateRes.code === 200 && candidateRes.data && candidateRes.data.bill) {
          receiveRes = candidateRes;
          break;
        }
      }

      if (receiveRes && receiveRes.data && receiveRes.data.bill) {
        const preRows = receiveRes.data.prebounds || [];
        const boundRows = receiveRes.data.bounds || [];
        const receiveBillStatus = Number((receiveRes.data.bill && receiveRes.data.bill.status) ?? NaN);
        const processed = !Number.isNaN(receiveBillStatus) && receiveBillStatus !== 0;

        if (preRows.length > 0) {
          const sourceStatusByDetailSerial = {};
          const sourceStatusBySerial = {};
          this.receiveBounds = preRows.map((item) => {
            const serialCode = (item.serialCode || "").trim().toUpperCase();
            const detailSerialKey = `${item.detailID || ""}_${serialCode}`;
            const key = `${item.id || item.ID || ""}_${item.serialCode || ""}`;
            const sourceStockNumber = sourceStockMap[key] != null
              ? sourceStockMap[key]
              : Number(item.sourceStockNumber || item.stockNumber || 0);
            const mappedAction = this.mapReceiveActionByStatus(item.status, processed);
            if (serialCode) {
              sourceStatusBySerial[serialCode] = item.status;
            }
            if (item.detailID && serialCode) {
              sourceStatusByDetailSerial[detailSerialKey] = item.status;
            }
            return {
              id: item.id || item.ID,
              detailID: item.detailID,
              detailCode: item.detailCode,
              detailName: item.detailName,
              brandModelCode: item.brandModelCode,
              unitName: item.unitName,
              serialCode: item.serialCode,
              storeCode: item.storeCode,
              channel: item.channel || item.channelCode,
              stockNumber: Number(item.stockNumber || 0),
              goldWeight: Number(item.goldWeight || 0),
              //productPrice: Number(item.productPrice || 0),
              sourceStockNumber,
              action: mappedAction,
              rejectRemark: mappedAction === "Reject" ? (item.remark || "") : "",
              status: item.status,
            };
          });

          this.sourceBounds = this.sourceBounds.map((item) => {
            const serialCode = (item.serialCode || "").trim().toUpperCase();
            const detailSerialKey = `${item.detailID || ""}_${serialCode}`;
            return {
              ...item,
              status: sourceStatusByDetailSerial[detailSerialKey] ?? sourceStatusBySerial[serialCode] ?? item.status,
            };
          });
        }
        this.receiveSelectedRows = [];

        this.receiveResultBounds = boundRows.map((item) => ({
          detailCode: item.detailCode,
          detailName: item.detailName,
          brandModelCode: item.brandModelCode,
          unitName: item.unitName,
          serialCode: item.serialCode,
          storeCode: item.storeCode,
          channel: item.channel,
          stockNumber: Number(item.stockNumber || 0),
          goldWeight: Number(item.goldWeight || 0),
          //productPrice: Number(item.productPrice || 0),
        }));

        this.receiveBill = receiveRes.data.bill;
      }
    },
    validateReceive() {
      if (!this.sourceBill || !this.sourceBill.billCode) return "请先查询来源出库单";
      if (!this.sourceBillCode) return "来源单号不能为空";
      return "";
    },
    parseReceiveSerials(rawText) {
      const normalized = (rawText || "")
        .replace(/[，；]/g, ",")
        .replace(/[\r\n\t ]+/g, ",");
      const list = normalized
        .split(",")
        .map((item) => (item || "").trim().toUpperCase())
        .filter((item) => !!item);
      return Array.from(new Set(list));
    },
    mapReceiveActionByStatus(status, processed) {
      const s = String(status ?? "");
      if (s === "-1") return "Reject";
      if (processed) return "Receive";
      return "";
    },
    markReceiveBySerialInput() {
      const serials = this.parseReceiveSerials(this.receiveSerialInput);
      if (serials.length === 0) {
        this.$message({ type: "warning", message: "请输入至少一个批次号" });
        return;
      }

      const receiveMap = {};
      this.receiveBounds.forEach((row) => {
        const key = (row.serialCode || "").trim().toUpperCase();
        if (!key) return;
        if (!receiveMap[key]) receiveMap[key] = [];
        receiveMap[key].push(row);
      });

      let hitCount = 0;
      let hitGoldWeightTotal = 0;
      const unmatched = [];
      serials.forEach((serial) => {
        const rows = receiveMap[serial] || [];
        if (rows.length === 0) {
          unmatched.push(serial);
          return;
        }
        rows.forEach((row) => {
          row.action = "Receive";
          row.rejectRemark = "";
          hitCount += 1;
          hitGoldWeightTotal += Number(row.stockNumber || 0) * Number(row.goldWeight || 0);
        });
      });

      this.receiveUnmatchedSerials = unmatched;
      if (hitCount > 0) {
        const summary = `已标记接收 ${hitCount} 条，金重合计 ${hitGoldWeightTotal.toFixed(2)} g`;
        this.$message({
          type: "success",
          message: unmatched.length > 0 ? `${summary}，${unmatched.length} 个批次号未命中` : summary,
        });
        this.receiveSerialInput = "";
      } else {
        this.$message({ type: "warning", message: "未命中任何可接收明细" });
      }
    },
    handleReceiveSelectionChange(selection) {
      this.receiveSelectedRows = selection || [];
    },
    batchSetReceiveAction(action) {
      if (!this.canOperateReceive || this.hasReceived) {
        this.$message({ type: "warning", message: "当前状态不可批量处理" });
        return;
      }
      if (!action || !["Receive", "Reject"].includes(action)) return;
      if (this.receiveSelectedRows.length === 0) {
        this.$message({ type: "warning", message: "请先勾选需要处理的明细" });
        return;
      }

      this.receiveSelectedRows.forEach((row) => {
        row.action = action;
        if (action === "Receive") row.rejectRemark = "";
      });
      this.$message({
        type: "success",
        message: `已批量设置 ${this.receiveSelectedRows.length} 条为${action === "Receive" ? "接收" : "拒绝"}`,
      });
    },
    submitReceiveResult() {
      const msg = this.validateReceive();
      if (msg) {
        this.$message({ type: "warning", message: msg });
        return;
      }

      if (!this.canOperateReceive) {
        this.$message({ type: "warning", message: "当前单据状态不可提交" });
        return;
      }

      if (this.receiveBounds.length === 0) {
        this.$message({ type: "warning", message: "未找到接收明细" });
        return;
      }

      const undecided = this.receiveBounds.filter((row) => !row.action);
      if (undecided.length > 0) {
        this.$message({ type: "warning", message: `存在 ${undecided.length} 条明细未决策，请逐条标记接收或拒绝` });
        return;
      }

      const details = this.receiveBounds.map((row) => ({
        id: row.id || "",
        serialCode: row.serialCode || "",
        status: row.action === "Receive" ? "1" : "-1",
        remark: row.action === "Reject" ? (row.rejectRemark || "") : "",
      }));

      this.$confirm(`确认提交调拨单【${this.sourceBillCode}】？接收 ${this.receiveActionCount} 条，拒绝 ${this.rejectActionCount} 条。`, "保存提交", {
        confirmButtonText: "确认提交",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.receiveLoading = true;
        submitCrossTransferSubmit(this.sourceBillCode, details)
          .then((res) => {
            this.$message({ type: res.type || "success", message: res.content || "保存提交成功" });
            if (res.code === 200) {
              this.loadBySourceBillCode();
            }
          })
          .finally(() => {
            this.receiveLoading = false;
          });
      }).catch(() => { });
    },
  },
  async created() {
    this.sourceCompanys = await this.$kaung.companys() || [];
    const companyTreeRes = await getCompanyTreeAll();
    this.targetCompanys = (companyTreeRes && companyTreeRes.code === 200) ? (companyTreeRes.data || []) : [];

    const stack = [...this.targetCompanys];
    while (stack.length > 0) {
      const item = stack.pop();
      if (!item) continue;
      const key = item.value || item.id;
      const name = item.label || item.companyName || item.name;
      if (key) this.companyMap[key] = name;
      if (item.children && item.children.length > 0) stack.push(...item.children);
    }

    this.saveForm.companyID = (this.$store.getters.getUserInfo || {}).companyID || "";
    this.$kaung.dictionary("stock", "store").then((res) => (this.dict.stores = res));
    this.$kaung.dictionary("stock", "channel").then((res) => (this.dict.channels = res));

    this.syncFromRoute();
  },
  watch: {
    '$route': {
      handler() {
        this.syncFromRoute();
      },
      deep: true,
    }
  }
};
</script>

<style lang="less" scoped>
.summary-row {
  margin-top: 10px;
  text-align: right;
  font-weight: 600;
}

.submit-row {
  margin-top: 0px;
  text-align: center;
}
</style>
